import { LoginPage as UiKitLoginPage } from '@idu-nightlife/ui-kit';
import React from 'react';
import AppLogo from '../../../assets/idu-logo-light.svg?react';

const instructions = `Sign in to access iDU`;

export const LoginPage: React.FC = () => {
  return (
    <UiKitLoginPage
      logo={AppLogo}
      instructions={instructions}
      hideSignup
      hideFooter
      enableGoogleLogin
    />
  );
};

export default LoginPage;
